import { render } from "./SbmDashboard.vue?vue&type=template&id=1907bfe1&scoped=true"
import script from "./SbmDashboard.vue?vue&type=script&lang=js"
export * from "./SbmDashboard.vue?vue&type=script&lang=js"

import "./SbmDashboard.vue?vue&type=style&index=0&id=1907bfe1&lang=css"
import "./SbmDashboard.vue?vue&type=style&index=1&id=1907bfe1&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1907bfe1"]])

export default __exports__